import service from '@/utils/request'

export function commodityList(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodity/commodityList',
        data: param
    })
}

export function commodityListAll() {
    return service.request({
        method: 'POST',
        url: '/app/commodity/list',
    })
}

export function addCommodity(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodity/add',
        data: param
    })
}

export function editCommodity(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodity/edit',
        data: param
    })
}

export function batchDelCommodity(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodity/batchDel',
        data: param
    })
}

export function delCommodity(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodity/del',
        data: param
    })
}

export function exportCommodity(param) {
    return service.request({
        method: 'POST',
        url: '/app/commodity/export',
        data: param
    })
}
